import { useEffect } from 'react'

export default function useDocumentTitle(title, appName = 'Tech4 Inventory') {
  useEffect(() => {
		if (!title) return;
    document.title = title ? `${title} - ${appName}` : appName

		return () => {
			document.title = appName;
		}
  }, [title])
}
